export const dtableFilter = {
  namespaced: true,
  state: {
    model: [],
    filters: []
  },
  mutations: {
    setModel(state, payload) {
      if (typeof payload.model !== 'undefined'
        && typeof payload.key !== 'undefined'
        && payload.key != null
        && payload.model !== null) {
        state.model[payload.key] = payload.model;
      }
    },
    setFilter(state, payload) {
      if (typeof payload.filter !== 'undefined'
        && typeof payload.key !== 'undefined'
        && payload.key != null
        && payload.filter !== null) {
        state.filters[payload.key] = payload.filter;
      }
    }
  }

}